export const CHART_COLORS = {
  neutral: "#1760aa",
  thumbsUp: "#1760aa",
  thumbsDown: "#f2994a",
  continued: "#7dd3fc",
  retried: "#0284c7",
  rageQuit: "#075985",
};

export const CHART_SURFACE = "#ffffff";

export const GRID_STROKE = "#e5e5e5";

export const AXIS_STROKE = "#dadee7";

export const AXIS_TICK = { fill: "#858585", fontSize: 12 };

export const BAR_MAX_SIZE = 24;

export const BAR_RADIUS: [number, number, number, number] = [4, 4, 0, 0];

export const CHART_HEIGHT = 260;

export const CHART_MARGIN = { top: 8, right: 8, bottom: 0, left: 0 };

export const MAX_DOTTED_POINTS = 45;

export const HOVER_CURSOR_FILL = "rgba(28, 33, 84, 0.06)";
